// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

.switch.active .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

.switch.active .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.delete-audience-confirm-modal{
    padding: 0;
}

.delete-audience-confirm-modal .modal-header{
    padding: 0px 0px;
    font-size: 14px;
}

.delete-audience-confirm-modal .modal-body{
    padding: 15px 0px;
    font-size: 14px;
}

.delete-audience-confirm-modal .modal-footer{
    padding: 6px 0px;
}

.delete-audience-confirm-modal .modal-title {
    font-size: 18px;
    line-height: 1.5;
}

/* Audience status below name - prominent badge */
.audience-status {
    font-size: 15px;
    margin: 10px 0px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.audience-status .audience-status-active,
.audience-status .audience-status-purged {
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    padding: 6px 14px;
    border-radius: 20px;
    letter-spacing: 0.3px;
}
.audience-status .audience-status-active {
    background-color: #28a745;
    color: #fff;
}
.audience-status .audience-status-purged {
    background-color: #ff2600;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./client/components/styles/audienceSystem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,iDAAiD;AACjD;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;;IAEI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\n.switch.active .slider {\n    background-color: #2196F3;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n}\n\n.switch.active .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n\n.delete-audience-confirm-modal{\n    padding: 0;\n}\n\n.delete-audience-confirm-modal .modal-header{\n    padding: 0px 0px;\n    font-size: 14px;\n}\n\n.delete-audience-confirm-modal .modal-body{\n    padding: 15px 0px;\n    font-size: 14px;\n}\n\n.delete-audience-confirm-modal .modal-footer{\n    padding: 6px 0px;\n}\n\n.delete-audience-confirm-modal .modal-title {\n    font-size: 18px;\n    line-height: 1.5;\n}\n\n/* Audience status below name - prominent badge */\n.audience-status {\n    font-size: 15px;\n    margin: 10px 0px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.audience-status .audience-status-active,\n.audience-status .audience-status-purged {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 6px 14px;\n    border-radius: 20px;\n    letter-spacing: 0.3px;\n}\n.audience-status .audience-status-active {\n    background-color: #28a745;\n    color: #fff;\n}\n.audience-status .audience-status-purged {\n    background-color: #ff2600;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
